import {
    Box,
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    Heading,
    Image,
    Link,
    Text,
    VStack,
    useColorModeValue,
} from "@chakra-ui/react";

import { Trans, useTranslation } from "react-i18next";
import { InterLink } from "../utils/InterLink";
import { PageTitle } from "../utils/PageTitle";

export function About() {
    const { t } = useTranslation();

    return (
        <Box>
            <Box position="relative" w="100%">
                <Image
                    src="/images/headings/heading-polaroid.jpg"
                    alt="heading-about"
                    w="100%"
                    h={{ base: 36, sm: 36, md: 56, lg: 72 }}
                    objectFit="cover"
                    objectPosition={"center center"}
                    shadow={"md"}
                />

                {/* original top={7} */}
                <Breadcrumb position="absolute" top={7} left={10} color={"white"}>
                    <BreadcrumbItem>
                        <BreadcrumbLink href="/">Garrigue Games</BreadcrumbLink>
                    </BreadcrumbItem>

                    <BreadcrumbItem fontWeight={"semibold"} isCurrentPage>
                        <BreadcrumbLink href="/about">{t("menuButtons.about")}</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>

            <VStack maxW={1536} p={10} alignItems={"left"}>
                <PageTitle>{t("about.title")}</PageTitle>
                <Text marginBottom={5} fontSize="md">
                    {t("about.paragraph1")}
                </Text>
                <Heading fontSize="2xl" fontWeight={"medium"} color={useColorModeValue("brand.500", "brand.400")}>
                    {t("about.heading1")}
                </Heading>
                <Text marginBottom={5} fontSize="sm">
                    {t("about.paragraph2")}
                </Text>
                <Heading fontSize="2xl" fontWeight={"medium"} color={useColorModeValue("brand.500", "brand.400")}>
                    {t("about.heading2")}
                </Heading>
                <Text marginBottom={5} fontSize="sm">
                    {t("about.paragraph3")}
                </Text>
                <Heading fontSize="2xl" fontWeight={"medium"} color={useColorModeValue("brand.500", "brand.400")}>
                    {t("about.heading3")}
                </Heading>
                <Text marginBottom={5} fontSize="sm">
                    <Trans
                        i18nKey="about.paragraph4"
                        components={{
                            brnogamedev: <Link href="https://www.brnogamedev.city/events/" isExternal />,
                            visiongame: <Link href="https://visiongame.cz/udalosti/" isExternal />,
                        }}
                    />
                </Text>
                <Heading fontSize="2xl" fontWeight={"medium"} color={useColorModeValue("brand.500", "brand.400")}>
                    {t("about.discordHeading")}
                </Heading>
                <Text marginBottom={5} fontSize="sm">
                    <Link href="https://discord.gg/yhk4REFngH" isExternal>
                        {t("about.discordParagraph")}
                    </Link>
                </Text>
                <Heading fontSize="2xl" fontWeight={"medium"} color={useColorModeValue("brand.500", "brand.400")}>
                    {t("about.heading4")}
                </Heading>
                <Text marginBottom={5} fontSize="sm">
                    <Trans
                        i18nKey="about.paragraph5"
                        components={{
                            presskit: <InterLink to="/presskit" />,
                        }}
                    />
                </Text>
            </VStack>
        </Box>
    );
}

export default About;
